"use strict";

var _classCallCheck = require("H:\\Dokumente\\Programmieren\\Webseiten\\svss-website\\svss-react-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("H:\\Dokumente\\Programmieren\\Webseiten\\svss-website\\svss-react-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("H:\\Dokumente\\Programmieren\\Webseiten\\svss-website\\svss-react-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _inherits = require("H:\\Dokumente\\Programmieren\\Webseiten\\svss-website\\svss-react-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _wrapNativeSuper = require("H:\\Dokumente\\Programmieren\\Webseiten\\svss-website\\svss-react-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateTimestamp;
exports.ValidationError = void 0;
var ValidationError = /*#__PURE__*/function (_Error) {
  _inherits(ValidationError, _Error);
  function ValidationError(name, message) {
    var _this;
    _classCallCheck(this, ValidationError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ValidationError).call(this, "Invalid \"".concat(name, "\" provided, ") + message));
    _this.name = 'ValidationError';
    return _this;
  }
  return ValidationError;
}(_wrapNativeSuper(Error));
exports.ValidationError = ValidationError;
function validateTimestamp(name, timestamp, options) {
  options = options || {};
  if (typeof timestamp !== 'number') {
    throw new ValidationError(name, "only numeric values are allowed for timestamps, provided type was \"".concat(typeof timestamp, "\""));
  }
  if (options.maximum && timestamp > options.maximum) {
    throw new ValidationError(name, "value (".concat(timestamp, ") cannot be further in the future than expected maximum (").concat(options.maximum, ")"));
  }
  if (options.now && timestamp < options.now) {
    throw new ValidationError(name, "value (".concat(timestamp, ") cannot be in the past, current time was ").concat(options.now));
  }
}